import { render, staticRenderFns } from "./xdslTable.vue?vue&type=template&id=6b071481&scoped=true&"
import script from "./xdslTable.vue?vue&type=script&lang=js&"
export * from "./xdslTable.vue?vue&type=script&lang=js&"
import style0 from "./xdslTable.vue?vue&type=style&index=0&id=6b071481&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b071481",
  null
  
)

export default component.exports